import Slider from "../../Models/SliderModels";

export default class SalesSlider extends Slider {
  constructor() {
    super(".sales-slider", {
      preloadImages: false,
      // lazy: true,
      slidesPerView: 1.25,
      slidesOffsetBefore: 16,
      spaceBetween: 16,
      breakpoints: {
        991: {
          slidesPerView: 1,
          centeredSlides: true,
          slidesOffsetBefore: 0,
        },
      },
    });
  }
}
